// "/" is the separator in erasure-report-view-service (QueryCreationContext.SEPARATOR).
// Search terms entered by the user are also split on this character so that values
// containing "/" do not silently become extra terms on the backend.
export const BACKEND_SEPARATOR = "/";

export const MAX_SEARCH_TERM_COUNT = 100;
export const MAX_JOINED_CHARACTER_COUNT = 1_600;

export function parseSearchTerms(raw: string, userDelimiter: string): string[] {
    const seen = new Set<string>();
    const searchTerms: string[] = [];

    for (const part of raw.split(userDelimiter)) {
        for (const candidate of part.split(BACKEND_SEPARATOR)) {
            const trimmed = candidate.trim();
            if (trimmed !== "" && !seen.has(trimmed)) {
                seen.add(trimmed);
                searchTerms.push(trimmed);
            }
        }
    }

    return searchTerms;
}

export function isSearchTermCountValid(searchTerms: string[]): boolean {
    return searchTerms.length <= MAX_SEARCH_TERM_COUNT;
}

export function isJoinedLengthValid(searchTerms: string[]): boolean {
    const separatorCount = Math.max(0, searchTerms.length - 1);
    const totalLength = searchTerms.reduce((sum, term) => sum + term.length, 0) + separatorCount;
    return totalLength <= MAX_JOINED_CHARACTER_COUNT;
}
